<router-outlet *ngIf="!(authService.isLoggedIn | async)"></router-outlet>
<tr-app-layout *ngIf="authService.isLoggedIn | async"></tr-app-layout>
<tr-toaster></tr-toaster>